export const mockBrowseProducts = [
  {
    id: "bp-001",
    name: "Steel Raised Garden Bed Kit 4x8ft",
    slug: "steel-raised-garden-bed-4x8",
    factory: "American Steel Works LLC — Ohio, USA",
    factorySlug: "american-steel-works",
    category: "Garden",
    price: 89.99,
    commission: 15,
    warehouse: "USA",
    totalSales: 9400,
    rating: 4.9,
    activeResellers: 38,
    image: "https://public.readdy.ai/ai/img_res/ec226599641cb29f2cf3ff9f0844f578.jpg",
  },
  {
    id: "bp-002",
    name: "Professional Garden Hose 100ft Heavy Duty",
    slug: "garden-hose-100ft",
    factory: "FlexPro Garden Supply Co. — Texas, USA",
    factorySlug: "american-steel-works",
    category: "Garden",
    price: 44.99,
    commission: 12,
    warehouse: "USA",
    totalSales: 18700,
    rating: 4.8,
    activeResellers: 52,
    image: "https://readdy.ai/api/search-image?query=professional%20heavy%20duty%20green%20garden%20hose%20100%20feet%20coiled%20neatly%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20brass%20fittings%20visible&width=400&height=300&seq=bp002&orientation=landscape",
  },
  {
    id: "bp-003",
    name: "Raw Wildflower Honey 32oz Glass Jar",
    slug: "wildflower-honey-32oz",
    factory: "Golden Prairie Apiary — Montana, USA",
    factorySlug: "golden-prairie-apiary",
    category: "Farm Products",
    price: 18.99,
    commission: 22,
    warehouse: "USA",
    totalSales: 34000,
    rating: 4.9,
    activeResellers: 91,
    image: "https://readdy.ai/api/search-image?query=raw%20wildflower%20honey%20in%20large%20glass%20jar%2032oz%20with%20wooden%20honey%20dipper%20on%20clean%20white%20background%2C%20artisan%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20natural%20rustic%20label&width=400&height=300&seq=bp003&orientation=landscape",
  },
  {
    id: "bp-004",
    name: "Pure Maple Syrup Gift Set Grade A 3-Pack",
    slug: "maple-syrup-gift-set",
    factory: "True North Maple Co. — Quebec, Canada",
    factorySlug: "true-north-maple",
    category: "Food",
    price: 34.99,
    commission: 18,
    warehouse: "Canada",
    totalSales: 28000,
    rating: 4.9,
    activeResellers: 74,
    image: "https://readdy.ai/api/search-image?query=pure%20canadian%20maple%20syrup%20gift%20set%20three%20glass%20bottles%20different%20grades%20on%20white%20background%2C%20food%20product%20photography%2C%20professional%20studio%20lighting%2C%20amber%20golden%20color%2C%20maple%20leaf%20label%2C%20premium%20packaging&width=400&height=300&seq=bp004&orientation=landscape",
  },
  {
    id: "bp-005",
    name: "Stainless Steel Insulated Tumbler 40oz",
    slug: "insulated-tumbler-40oz",
    factory: "HomeStyle Furniture Works — Foshan",
    factorySlug: "american-steel-works",
    category: "Home Goods",
    price: 11.99,
    commission: 20,
    warehouse: "Both",
    totalSales: 32000,
    rating: 4.9,
    activeResellers: 118,
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20tumbler%2040oz%20with%20handle%20and%20straw%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20matte%20black%20finish&width=400&height=300&seq=bp005&orientation=landscape",
  },
  {
    id: "bp-006",
    name: "Vitamin C Brightening Serum 30ml",
    slug: "vitamin-c-serum-30ml",
    factory: "BeautyGlow Cosmetics Ltd. — Shanghai",
    factorySlug: "american-steel-works",
    category: "Beauty",
    price: 8.99,
    commission: 25,
    warehouse: "Both",
    totalSales: 28000,
    rating: 4.8,
    activeResellers: 143,
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20face%20serum%20glass%20bottle%20with%20dropper%20on%20white%20background%2C%20skincare%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20orange%20and%20white%20packaging&width=400&height=300&seq=bp006&orientation=landscape",
  },
  {
    id: "bp-007",
    name: "Birch Wood End-Grain Cutting Board 18x12in",
    slug: "birch-cutting-board-18x12",
    factory: "True North Maple Co. — Quebec, Canada",
    factorySlug: "true-north-maple",
    category: "Home Goods",
    price: 44.99,
    commission: 16,
    warehouse: "Canada",
    totalSales: 17800,
    rating: 4.9,
    activeResellers: 45,
    image: "https://readdy.ai/api/search-image?query=large%20birch%20wood%20cutting%20board%2018x12%20inches%20with%20juice%20groove%20on%20white%20background%2C%20kitchen%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%2C%20end%20grain%20design%2C%20premium%20quality&width=400&height=300&seq=bp007&orientation=landscape",
  },
  {
    id: "bp-008",
    name: "Cold-Pressed Extra Virgin Olive Oil 1 Gallon",
    slug: "olive-oil-1-gallon",
    factory: "California Olive Ranch — California, USA",
    factorySlug: "golden-prairie-apiary",
    category: "Farm Products",
    price: 44.99,
    commission: 14,
    warehouse: "USA",
    totalSales: 41000,
    rating: 4.9,
    activeResellers: 87,
    image: "https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%201%20gallon%20tin%20can%20on%20white%20background%2C%20california%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20gold%20label%2C%20premium%20cold%20pressed%20olive%20oil%2C%20american%20grown&width=400&height=300&seq=bp008&orientation=landscape",
  },
  {
    id: "bp-009",
    name: "Professional Bypass Pruning Shears",
    slug: "bypass-pruning-shears",
    factory: "PowerGarden Tools USA — Georgia, USA",
    factorySlug: "american-steel-works",
    category: "Garden",
    price: 24.99,
    commission: 18,
    warehouse: "USA",
    totalSales: 31000,
    rating: 4.9,
    activeResellers: 66,
    image: "https://readdy.ai/api/search-image?query=professional%20bypass%20pruning%20shears%20garden%20scissors%20with%20red%20handles%20on%20white%20background%2C%20garden%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20sharp%20stainless%20steel%20blades%2C%20ergonomic%20grip&width=400&height=300&seq=bp009&orientation=landscape",
  },
  {
    id: "bp-010",
    name: "Organic Dried Cranberries 5lb Bag",
    slug: "dried-cranberries-5lb",
    factory: "Cape Cod Berry Farms — Massachusetts, USA",
    factorySlug: "golden-prairie-apiary",
    category: "Farm Products",
    price: 22.99,
    commission: 20,
    warehouse: "USA",
    totalSales: 15600,
    rating: 4.8,
    activeResellers: 39,
    image: "https://readdy.ai/api/search-image?query=organic%20dried%20cranberries%205%20pound%20bag%20on%20white%20background%2C%20farm%20berry%20product%20photography%2C%20professional%20studio%20lighting%2C%20deep%20red%20color%2C%20natural%20kraft%20packaging%2C%20massachusetts%20cranberry%20farm&width=400&height=300&seq=bp010&orientation=landscape",
  },
  {
    id: "bp-011",
    name: "Soy Candle Set Cedar and Pine 3-Pack",
    slug: "soy-candle-set-cedar-pine",
    factory: "True North Maple Co. — Quebec, Canada",
    factorySlug: "true-north-maple",
    category: "Home Goods",
    price: 28.99,
    commission: 28,
    warehouse: "Canada",
    totalSales: 15300,
    rating: 4.9,
    activeResellers: 57,
    image: "https://readdy.ai/api/search-image?query=handcrafted%20soy%20candle%20set%20three%20pack%20cedar%20and%20pine%20scent%20in%20glass%20jars%20on%20white%20background%2C%20home%20decor%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20label%2C%20warm%20cozy%20aesthetic&width=400&height=300&seq=bp011&orientation=landscape",
  },
  {
    id: "bp-012",
    name: "Fresh Dried Lavender Bundles 12-Pack",
    slug: "dried-lavender-bundles-12pack",
    factory: "Pacific Coast Lavender Farm — Washington, USA",
    factorySlug: "golden-prairie-apiary",
    category: "Farm Products",
    price: 29.99,
    commission: 24,
    warehouse: "USA",
    totalSales: 19500,
    rating: 4.9,
    activeResellers: 62,
    image: "https://readdy.ai/api/search-image?query=dried%20lavender%20bundles%20tied%20with%20twine%20on%20white%20background%2C%20farm%20botanical%20product%20photography%2C%20professional%20studio%20lighting%2C%20purple%20lavender%20flowers%2C%20aromatic%20herb%20bundle%2C%20washington%20state%20farm&width=400&height=300&seq=bp012&orientation=landscape",
  },
  {
    id: "bp-013",
    name: "Artisan Aged Cheddar Cheese 5lb Block",
    slug: "aged-cheddar-5lb",
    factory: "Wisconsin Dairy Farms Co. — Wisconsin, USA",
    factorySlug: "golden-prairie-apiary",
    category: "Farm Products",
    price: 54.99,
    commission: 16,
    warehouse: "USA",
    totalSales: 26000,
    rating: 4.9,
    activeResellers: 48,
    image: "https://readdy.ai/api/search-image?query=artisan%20aged%20cheddar%20cheese%20block%205%20pounds%20on%20white%20background%2C%20dairy%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20orange%20color%2C%20natural%20rind%2C%20premium%20wisconsin%20cheese&width=400&height=300&seq=bp013&orientation=landscape",
  },
  {
    id: "bp-014",
    name: "Wooden Cedar Planter Box 36-inch",
    slug: "cedar-planter-box-36in",
    factory: "NatureCraft Woodworks USA — Vermont, USA",
    factorySlug: "american-steel-works",
    category: "Garden",
    price: 64.99,
    commission: 14,
    warehouse: "USA",
    totalSales: 4300,
    rating: 4.9,
    activeResellers: 21,
    image: "https://readdy.ai/api/search-image?query=beautiful%20natural%20cedar%20wood%20planter%20box%2036%20inch%20with%20plants%20growing%20inside%20on%20white%20background%2C%20outdoor%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%20texture&width=400&height=300&seq=bp014&orientation=landscape",
  },
  {
    id: "bp-015",
    name: "Native Canadian Wildflower Seed Mix 1lb",
    slug: "wildflower-seed-mix-1lb",
    factory: "Prairie Natural Products — Alberta, Canada",
    factorySlug: "true-north-maple",
    category: "Garden",
    price: 22.99,
    commission: 30,
    warehouse: "Canada",
    totalSales: 8900,
    rating: 4.8,
    activeResellers: 33,
    image: "https://readdy.ai/api/search-image?query=wildflower%20seed%20mix%20bag%201%20pound%20with%20colorful%20flower%20illustrations%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20paper%20packaging%2C%20canadian%20native%20species&width=400&height=300&seq=bp015&orientation=landscape",
  },
  {
    id: "bp-016",
    name: "Farm-Fresh Free-Range Eggs 5 Dozen",
    slug: "free-range-eggs-5dozen",
    factory: "Blue Ridge Poultry Farm — Virginia, USA",
    factorySlug: "golden-prairie-apiary",
    category: "Farm Products",
    price: 34.99,
    commission: 10,
    warehouse: "USA",
    totalSales: 48000,
    rating: 4.9,
    activeResellers: 105,
    image: "https://readdy.ai/api/search-image?query=farm%20fresh%20free%20range%20eggs%20in%20cardboard%20carton%20on%20white%20background%2C%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20brown%20and%20white%20eggs%2C%20natural%20rustic%20packaging%2C%20virginia%20poultry%20farm&width=400&height=300&seq=bp016&orientation=landscape",
  },
];
